import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public url;
  constructor() {
      // this.url = 'http://localhost/codeigniter/admin/';
      // this.url = 'http://localhost/codeigniter/ppl-admin/admin/';
      //this.url = 'http://localhost/codeigniter/ppl-admin/';
      //this.url = 'http://localhost/codeigniter/pacificuniversity/';
       this.url = 'https://puadmin.modevcloud.com/';
       //this.url = 'https://www.pacificuniversity.ac.in/admin/';
  }
}
